import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-region-indicator-item/jb-region-indicator-item.scss?inline
var jb_region_indicator_item_default = i`@charset "UTF-8";
*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
span {
  font-family: var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-regular-weight, 400);
}

span {
  font-size: var(--theme-typo-p-mini-highlight-desktop-fontsize, 0.813rem);
  line-height: var(--theme-typo-p-mini-highlight-desktop-lineheight, 1.25rem);
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

li {
  align-items: center;
  color: white;
  display: inline-flex;
  list-style: none;
  position: relative;
}
li::after {
  color: rgb(var(--rgb-primary, 255, 255, 255));
  content: " · ";
  display: var(--dot-display, none);
  font-size: 1rem;
  font-weight: 700;
  line-height: 2.25rem;
}

span {
  color: rgb(var(--rgb-primary, 255, 255, 255));
  display: inline-block;
  line-height: 2.25rem;
  text-decoration: none;
}
span:not(.short) {
  display: none;
}
@media (min-width: 1281px) {
  span:not(.short) {
    display: inline;
  }
  span.short {
    display: none;
  }
}
span.short {
  text-transform: uppercase;
}`;

// src/components/jb-region-indicator-item/jb-region-indicator-item.ts
var JbRegionIndicatorItem = class extends r2 {
  constructor() {
    super(...arguments);
    this.hasGlobe = false;
  }
  render() {
    return ke`
      <li>
        ${this.hasGlobe ? ke`<jb-globe-icon><span class="short">${this.text}</span><span>${this.textFull}</span></jb-globe-icon>` : ke`<span class="short">${this.text}</span><span>${this.textFull}</span>`}
      </li>
    `;
  }
};
JbRegionIndicatorItem.styles = r(jb_region_indicator_item_default);
__decorateClass([
  n({ type: Boolean })
], JbRegionIndicatorItem.prototype, "hasGlobe", 2);
__decorateClass([
  n()
], JbRegionIndicatorItem.prototype, "text", 2);
__decorateClass([
  n()
], JbRegionIndicatorItem.prototype, "textFull", 2);
JbRegionIndicatorItem = __decorateClass([
  customElement("jb-region-indicator-item")
], JbRegionIndicatorItem);

export {
  JbRegionIndicatorItem
};
